<template>
    <div class="promocode-input">
        <div class="promocode-input__inner">
            <input
                v-model="code"
                type="text"
                class="promocode-input__input"
                :class="{ 'has-error': error && error.promo_code }"
                @keyup="onInput"
            />
            <transition name="fade">
                <div v-if="error && error['promo_code']" class="promocode-input__error">
                    {{ error.promo_code[0] }}
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PromocodeInput',
    props: {
        debounce: {
            type: Number,
            default: 400
        },
        error: {
            type: Object,
            default: () => {}
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            code: '',
            timeout: undefined
        };
    },
    methods: {
        onInput() {
            clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                this.$emit('update:modelValue', this.code);
            }, this.debounce);
        }
    }
};
</script>

<style lang="scss" src="./PromocodeInput.scss"></style>
